import { useEffect } from 'react';

import type { ViewerData } from '@xing-com/hub';
import { useViewerData, useVisitorId } from '@xing-com/hub';

/**
 * Calls Dash0's `identify()` to associate RUM telemetry with the current user.
 *
 * - LOGGED_IN / SOFT_LOGGED_IN: identifies by user ID, name, and hashed user ID
 * - LOGGED_OUT: identifies by the anonymous visitor ID (UUID cookie)
 */
export const Dash0Identify: React.FC = () => {
  const { data: viewerData, loading } = useViewerData();
  const visitorId = useVisitorId();

  useEffect(() => {
    const dash0Rum = globalThis.DASH0_RUM;
    if (!dash0Rum) {
      return;
    }

    if (loading || !viewerData) {
      return;
    }

    if (viewerData.loginState === 'LOGGED_OUT' || !viewerData.user) {
      // Anonymous user: identify by visitor ID
      dash0Rum.identify(visitorId);
      return;
    }

    const { user, hashedUserId } = viewerData as ViewerData & {
      user: NonNullable<ViewerData['user']>;
    };

    dash0Rum.identify(user.id, {
      name: user.displayName,
      fullName:
        [user.firstName, user.lastName].filter(Boolean).join(' ') || undefined,
      hash: hashedUserId,
    });
  }, [viewerData, loading, visitorId]);

  return null;
};
